import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {Serializer, SerializerResponse, Serializers} from '../interfaces/serializer';
import {Site} from '../interfaces/site';
import {Notification} from "../interfaces/notification";
import {tap} from "rxjs/operators";
import {SerializerUtils} from "../libraries/serializer-utils";

@Injectable({
  providedIn: 'root'
})
export class NotificationCenterService {

  constructor(
    private readonly _http: HttpClient,
  ) {}

  public getNotifications(dataSet: Serializer<Site>): Observable<SerializerResponse<Serializers<Notification>>> {
    return this._http.get<SerializerResponse<Serializers<Notification>>>(`${environment.baseUrl}/api/${dataSet.id}/notifications`).pipe(
      tap((response: SerializerResponse<Serializers<Notification>>) => {
        response.data.forEach(notification => {
          notification.relationships.notification_datas.data.forEach((notification_data, index: number) => {
            notification.relationships.notification_datas.data[index] = response.included.find(included => included.id === notification_data.id && included.type === 'notification_data');
          })
        });

        SerializerUtils.joinRelationships(response, ['data_set', 'models']);
      })
    );
  }

  public markAsRead(dataSet: Serializer<Site>, notification: Serializer<Notification>): Observable<SerializerResponse<Serializer<Notification>>> {
    return this._http.delete<SerializerResponse<Serializer<Notification>>>(`${environment.baseUrl}/api/${dataSet.id}/notifications/${notification.id}/mark-as-read`);
  }

  public deleteInfoNotifications(dataSet: Serializer<Site>): Observable<SerializerResponse<Serializers<Notification>>> {
    return this._http.delete<SerializerResponse<Serializers<Notification>>>(`${environment.baseUrl}/api/${dataSet.id}/notifications/delete-info-notifications`).pipe(
      tap((response: SerializerResponse<Serializers<Notification>>) => {
        response.data.forEach(notification => {
          notification.relationships.notification_datas.data.forEach((notification_data, index: number) => {
            notification.relationships.notification_datas.data[index] = response.included.find(included => included.id === notification_data.id && included.type === 'notification_data');
          })
        });

        SerializerUtils.joinRelationships(response, ['data_set', 'models']);
      })
    );
  }

}
